export default __webpack_public_path__ + "c4d42aaa5a9afbf325d0238701363ee1.png";